import script from "./TurnoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TurnoCard.vue?vue&type=script&setup=true&lang=js"

import "./TurnoCard.vue?vue&type=style&index=0&id=e504d164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e504d164"]])

export default __exports__